import changeItemIndex from '@teetsh/app/src/utils/arrays/changeItemAtIndex';

export default function swap<T>(list: T[], index: number, diff: -1 | 1): T[] {
  return changeItemIndex(list, index, index + diff);
}
